import Table from '/src/components/table/Table.js';

import { useState, useEffect } from 'react';
import ApiModal from '/src/components/modal/ApiModal/ApiModal';
import capitalizeFirstLetter from '../../../../../../utils/capitalizeFirstLetter';
import Icons from '/src/features/phone/data/types/Icons';

import './ConversationTableCompleted.css';
import ConversationDetailsModal from '../../ConversationDetailsModal/ConversationDetailsModal';
import NiceModal from '@ebay/nice-modal-react';
import ConversationFilterModal from '../../ConversationFilter/ConversationFilterModal';
import { formatDateWithoutSeconds } from '/src/utils/dateWithoutSeconds';
import formatPhoneNumber from '/src/utils/formatPhoneNumber';
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';
import ConversationMarker from '../../ConversationMarker/ConversationMarker';
import IconButton from '/src/components/UI/Button/IconButton/IconButton';
import ConversationCompletedService from '../../../services/ConversationCompletedService';
import { getStorageParamForCurrentCompany } from '/src/utils/storageParamForCurrentCompany';
import getCutToken from "/src/utils/getCutToken";
import { getDuration, getMessagesDuration } from '../../../data/getDuration';
import getNumberOfInteraction from '../../../data/getNumberOfInteraction';
import ConversationLogsModal from '../../ConversationLogsModal/ConversationLogsModal';
import hasPermission from '/src/utils/hasPermission';

function ConversationTableCompleted({ setRefreshList }) {

    const { getConversations, deleteConversation } = ConversationCompletedService;

    const urlParams = new URLSearchParams(window.location.search);
    const filters = getStorageParamForCurrentCompany('conversation_filters');

    if (filters.conversation_id) {
        delete filters.conversation_id;
    }

    const conversation_id = urlParams.get('conversation_id');
    if (conversation_id) filters.conversation_id = conversation_id;

    const [filterValues, setFilterValues] = useState(filters);
    const [refreshTable, setRefreshTable] = useState(false)



    const toast = useToastDispatchContext();

    const cells = [
        {
            name: 'channel_type.name',
            column: 'Channel',
            show: (value) => <img width="20px" srcSet={Icons[value]}></img>
        },
        /*
        {
            name: 'instance_id',
            column: 'ID',
            show : (value) =><span style={{color : "var(--main)", cursor: "pointer"}} onClick={(e) => navigator.clipboard.writeText(value).then(_ => { toast.success('Copy token to clipboard', 'You can paste this token where you need !',5000); })}>  {getCutToken(value) }</span>,
        },
        */

        {
            name: 'created_at',
            column: 'Date',
            show: (value) => formatDateWithoutSeconds(value),
            sort: true
        },
        {
            name: 'bot.name',
            column: 'Bot',
            show: (value) => capitalizeFirstLetter(value),
            sort: true
        },
        {
            name: ['duration', 'conversation_telephony_created_at', 'messages', 'updated_at'],
            // column: 'Duration',
            column: 'Total Time',
            show: ([duration, time, messages, updated_at]) => (time || duration) ? getDuration(duration, time, messages, updated_at) : null
        },
        {
            name: ['duration', 'conversation_telephony_created_at', 'messages', 'updated_at'],
            // column: 'Duration',
            column: 'Bot Time',
            show: ([duration, time, messages, updated_at]) => (time || duration) ? getMessagesDuration(time, messages, updated_at) : null
        },
        {
            name: 'messages',
            column: 'NB',
            show: (value) => getNumberOfInteraction(value),
        },
        {
            name: 'caller',
            column: 'Caller',
            show: (value) =>
                <span style={{ color: "var(--main)", cursor: "pointer", fontSize: "11px" }}
                    onClick={(e) =>
                        navigator.clipboard.writeText(value).then((_) => {
                            toast.success(
                                "Copy phone number to clipboard",
                                "You can paste this phone number where you need !",
                                5000
                            );
                        })
                    }>{formatPhoneNumber(value)}</span>
        },
        {
            name: 'numbers',
            column: 'Called',
            show: (value) =>
                <span style={{ color: "var(--main)", cursor: "pointer", fontSize: "11px" }}
                    onClick={(e) =>
                        navigator.clipboard.writeText(value).then((_) => {
                            toast.success(
                                "Copy phone number to clipboard",
                                "You can paste this phone number where you need !",
                                5000
                            );
                        })
                    }>{formatPhoneNumber(value)}</span>
        },
        {
            name: 'markers',
            column: 'Markers',
            show: (value) => <div className='list_makers_conversation_table'> {value.map((marker, i) => i < 4 && (<ConversationMarker marker={marker} key={i} className={i != 0 ? "superposition_maker_conversation_circle" : ""} style={{ left: "-" + 9 * i + "px", zIndex: i }} />))}</div>

        },

    ];

    const onClickRefresh = () => {
        setRefreshTable(!refreshTable);
    }

    const handleFilterSubmit = (filters) => {
        setFilterValues(filters);
    };

    const handleTableRefresh = () => {
        setRefreshTable(!refreshTable); // Mettre à jour le tableau
    }

    const onClickFilter = () => {
        NiceModal.show(ConversationFilterModal, {
            title: 'Filter conversations',
            postbackAction: handleFilterSubmit,
            mode: 0
        })
    }
    const onClickView = ({ updateRow, row }) => {
        NiceModal.show(ConversationDetailsModal, {
            data: row,
            title: 'Conversation details',
            state: 1,
            onRefresh: handleTableRefresh
        }).then((conversation) => updateRow(conversation))
    }
    const onClickShowLogs = ({ row }) => {
        NiceModal.show(ConversationLogsModal, {
            data: row,
            title: 'Conversation logs'
        })
    }

    const onClickDelete = ({ row, deleteRow }) => {
        const { instance_id, id, bot } = row;
        NiceModal.show(ApiModal, {
            title: 'Delete conversation',
            body: 'Do you really want to delete conversation from the bot ' + bot.name + '?',
            api: {
                request: deleteConversation,
                param: [id]
            },
            buttons: [
                { className: 'validate', label: 'Cancel' },
                { className: 'cancel', label: 'Delete', type: 'submit' },
            ],
            confirm: {
                name: bot.name,
                fieldName: "the bot",
            }
        }).then(() => deleteRow(id))
    };
    const actions = [
        { className: "fas fa-file-alt action-button profil_action", style: {}, onClick: onClickView, title: "Details" },
        hasPermission("view_conversations") && { className: "fas fa-file-invoice action-button profil_action", style: {}, onClick: onClickShowLogs, title: "Logs" },
        // {className : "fas fa-thumbtack action-button profil_action", style : { }, onClick : onClickView,title: "mark conversation" },
        hasPermission("delete_conversation") && { className: "fas fa-trash action-button delete_action", style: {}, onClick: onClickDelete, title: "Delete conversation" },
    ].filter(action => action);
    const buttons = [
        { icon: "fas fa-sync", onClick: onClickRefresh },
        { className: "main-iconButton profil_action main_add-button" + (!Object.keys(filterValues).length == 0 ? " conversations_active_filter" : ""), icon: "fas fa-filter", onClick: onClickFilter },

    ].filter(button => button);


    useEffect(() => {
        setRefreshList();
    }, [filterValues])

    return (
        <Table name="last conversation" buttons={buttons} filterValues={filterValues} refreshState={[refreshTable, setRefreshTable]} className='table-conversation' cells={cells} api={getConversations} actions={actions}></Table>
    );
}

export default ConversationTableCompleted;